<template>
  <Bandeau :content="getContent()"></Bandeau>
</template>

<script>
import Bandeau from '@/components/base/bandeau/Bandeau.vue';

export default {
  name: 'BandeauNavigateurNonSupporte',
  components: {
    Bandeau,
  },

  i18n: {
    messages: {
      fr: {
        titre: 'Oups! Ce navigateur n’est plus pris en charge.',
        texte:
          'Nous vous invitons à utiliser un navigateur plus récent si vous voulez profiter de toutes les fonctionnalités du site.',
        hyperlien: 'https://www.espacejeux.com/fr/aide-technique',
        texteHyperlien: 'Mettre à jour votre navigateur',
      },
      en: {
        titre: 'Oops! This browser is no longer supported.',
        texte: 'Please use a more recent browser if you want to enjoy all of the site’s features.',
        hyperlien: 'https://www.espacejeux.com/en/technical-help',
        texteHyperlien: 'Update your browser',
      },
    },
  },

  methods: {
    getContent() {
      return {
        titre: this.$t('titre'),
        texte: this.$t('texte'),
        hyperlien: this.$t('hyperlien'),
        texteHyperlien: this.$t('texteHyperlien'),
        image: {
          '@path': '/jel/images/ico-nav-non-supporte.svg',
        },
        altImage: '',
      };
    },
  },
};
</script>
